import {css} from '@genesislcap/web-core';

export const HelpMenuStyles = css`
  :host {
    font-size: var(--type-ramp-plus-4-font-size);
    padding: calc(var(--design-unit) * 3px);
    color: var(--neutral-fill-strong-rest);
    cursor: pointer;
    position: relative;
  }
  
  rapid-icon {
    color: var(--neutral-fill-strong-rest);
  }
`;
